import {PoiType} from "../types/PoiType";

export const POI_COLORS: Partial<Record<PoiType, string>> = {
    [PoiType.OFFERS]: "var(--colors-gray-400)",
    [PoiType.TRANSPORT]: "var(--colors-info)",
    [PoiType.FOOD]: "var(--colors-gray-300)",
    [PoiType.SHOPS]: "var(--colors-warning)",
    [PoiType.SPORT]: "var(--colors-background-200)",
    [PoiType.HEALTH]: "var(--colors-highlight)",
    [PoiType.EDUCATION]: "var(--colors-success)",
    [PoiType.ENTERTAINMENT]: "#FFE86F"
};
import {PoiType} from "../types/PoiType";

export const POI_COLORS: Partial<Record<PoiType, string>> = {
    [PoiType.OFFERS]: "var(--colors-gray-400)",
    [PoiType.TRANSPORT]: "var(--colors-info)",
    [PoiType.FOOD]: "var(--colors-gray-300)",
    [PoiType.SHOPS]: "var(--colors-warning)",
    [PoiType.SPORT]: "var(--colors-background-200)",
    [PoiType.HEALTH]: "var(--colors-highlight)",
    [PoiType.EDUCATION]: "var(--colors-success)",
    [PoiType.ENTERTAINMENT]: "#FFE86F"
};
